import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { OperationsService } from '../../../../services/operations.service';

@Component({
  selector: 'app-validate-courier',
  templateUrl: './validate-courier.component.html',
  styleUrls: ['./validate-courier.component.scss']
})
export class ValidateCourierComponent implements OnInit {

  constructor(private operationService: OperationsService) { }

  ngOnInit() {
  }
  @Output() shipments = new EventEmitter();
  searchCourierInProgress = "";
  validateTxt = "Validate"
  validCourier = false;
  showCourierSection = false;
  startEnabled = false;
  ok = "<i class='armx-ok'></i>";
  courier = {
    name: "",
    showCourierSection: false,
    showLocationAssignedSection: false,
    showErrorMessage: false,
    showNumberOfShipments: false,
    shipmentsCount: 0,
    errorMessage: false,
    location: "",
    city: "",
    courierId:""
  };
  CourierIdValid = true;
 Resevicedshipments =[];
  courierId = "";
  changeCourierId() {
    this.CourierIdValid = true;
    this.searchCourierInProgress = "";
    this.validateTxt = "Validate";
    this.validCourier = false;
  }
  validateCourier() {
    if (this.courierId.trim() == "") {
      this.CourierIdValid = false;
      return;
    }
    this.CourierIdValid = true;
    this.searchCourierInProgress = "search-courier-inprogress"
   
    this.operationService.validateCourierId(this.courierId, (res) => {
      if (res.redirectionUrl != null) {
        
        window.open(res.redirectionUrl,"_blank")
      }
      if (res.CourierDetails != null) {
        this.courier.showCourierSection = true;
        this.courier.showLocationAssignedSection = true;
        this.courier.location = JSON.parse(sessionStorage.getItem("branch")).branch.BranchDisplayName;
        this.courier.city = JSON.parse(sessionStorage.getItem("branch")).branch.BranchCity;
        this.courier.name = res.CourierDetails.CourierName;
        this.courier.courierId = this.courierId;
      }
      else {
        this.courier.showCourierSection = false;
        this.courier.showLocationAssignedSection = false;
      }
      
      if (res.messageStatus != null) {
        this.courier.showErrorMessage = true;
        this.startEnabled = false;
        this.courier.errorMessage = res.messageStatus;
        this.courier.showNumberOfShipments = false;
       
      }
      else {
        this.startEnabled = true;
        this.courier.showErrorMessage = false;
        this.courier.showNumberOfShipments = true;
        this.courier.shipmentsCount = res.spotripsLocationsShipments.length;
        this.Resevicedshipments = res.spotripsLocationsShipments
      }
      
      this.searchCourierInProgress = "";
      this.validCourier = true;
      this.validateTxt = this.ok;
      this.showCourierSection = true;

    }, () => { })
  }


  start() {
    this.shipments.emit(this.Resevicedshipments);
  }

}
